import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50351567"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page_wrap" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["autoplay"]
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 对不起，本浏览器不支持视频播放 ")
const _hoisted_6 = { class: "titles" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "page_content_wrap" }
const _hoisted_10 = {
  key: 9,
  style: {"padding":"100px 0px 0px 0px"}
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Home = _resolveComponent("Home")!
  const _component_Research = _resolveComponent("Research")!
  const _component_Contact = _resolveComponent("Contact")!
  const _component_Services = _resolveComponent("Services")!
  const _component_Brochure = _resolveComponent("Brochure")!
  const _component_About = _resolveComponent("About")!
  const _component_CasesRegion = _resolveComponent("CasesRegion")!
  const _component_CasesClients = _resolveComponent("CasesClients")!
  const _component_CasesCategories = _resolveComponent("CasesCategories")!
  const _component_HotelLocator = _resolveComponent("HotelLocator")!
  const _component_ToolListBW = _resolveComponent("ToolListBW")!
  const _component_ToolListMC = _resolveComponent("ToolListMC")!
  const _component_ToolListHotels = _resolveComponent("ToolListHotels")!
  const _component_CallForAction = _resolveComponent("CallForAction")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ((!_ctx.headVideo) || _ctx.headVideo.length<=0 || _ctx.isMobile())
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.headImage,
          class: _normalizeClass({
            head_image:true, 
            _corner:_ctx.pageName.includes('contact'), 
            _right:_ctx.pageName.includes('home'),
        }),
          alt: "",
          style: _normalizeStyle(`filter:brightness(${_ctx.brightness})`)
        }, null, 14, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.headVideo.length>0 && !_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("video", {
          key: 1,
          autoplay: _ctx.windowWidth > 800,
          loop: "",
          muted: "",
          class: _normalizeClass({head_image:true, _corner:_ctx.pageName.includes('联系')}),
          alt: ""
        }, [
          _createElementVNode("source", {
            src: _ctx.headVideo,
            type: "video/mp4"
          }, null, 8, _hoisted_4),
          _hoisted_5
        ], 10, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        innerHTML: _ctx.pageTitle,
        style: _normalizeStyle(`color:${_ctx.titleColor};text-shadow: 1px 1px 3px ${_ctx.shadowColor};`),
        class: _normalizeClass({_page_title:true, text_shadow:true})
      }, null, 12, _hoisted_7),
      (_ctx.pageSubTitle && _ctx.pageSubTitle.length>0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            innerHTML: _ctx.pageSubTitle,
            class: "_page_subtitle",
            style: _normalizeStyle(`color:${_ctx.titleColor};text-shadow: 1px 1px ${_ctx.pageName.includes('home') ? 6 : 3}px ${_ctx.shadowColor};`)
          }, null, 12, _hoisted_8))
        : _createCommentVNode("", true),
      (_ctx.pageHeadArticle && _ctx.pageHeadArticle.length>0)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "_page_headarticle",
            style: _normalizeStyle(`text-shadow: 1px 1px ${_ctx.pageName.includes('home') ? 6 : 3}px ${_ctx.shadowColor};`),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickPageHeadArticle && _ctx.onClickPageHeadArticle(...args)))
          }, " 点击了解更多 ", 4))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", null, [
        (_ctx.pageName=='home')
          ? (_openBlock(), _createBlock(_component_Home, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.pageName=='research')
          ? (_openBlock(), _createBlock(_component_Research, {
              key: 1,
              currTab: _ctx.tabs.includes(_ctx.currTab) ? _ctx.currTab : _ctx.tabs[0]
            }, null, 8, ["currTab"]))
          : _createCommentVNode("", true),
        (_ctx.pageName=='contact')
          ? (_openBlock(), _createBlock(_component_Contact, { key: 2 }))
          : _createCommentVNode("", true),
        (_ctx.pageName=='services')
          ? (_openBlock(), _createBlock(_component_Services, {
              key: 3,
              scrollCount: _ctx.scrollCount,
              scrollId: _ctx.scrollId
            }, null, 8, ["scrollCount", "scrollId"]))
          : _createCommentVNode("", true),
        (_ctx.pageName=='about' && _ctx.currTab =='华美\n简介')
          ? (_openBlock(), _createBlock(_component_Brochure, {
              key: 4,
              currTab: _ctx.tabs.includes(_ctx.currTab) ? _ctx.currTab : _ctx.tabs[0]
            }, null, 8, ["currTab"]))
          : _createCommentVNode("", true),
        (_ctx.pageName=='about' && _ctx.currTab!='华美\n简介')
          ? (_openBlock(), _createBlock(_component_About, {
              key: 5,
              currTab: _ctx.tabs.includes(_ctx.currTab) ? _ctx.currTab : _ctx.tabs[0]
            }, null, 8, ["currTab"]))
          : _createCommentVNode("", true),
        (_ctx.pageName=='cases' && _ctx.currTab=='项目\n分布')
          ? (_openBlock(), _createBlock(_component_CasesRegion, { key: 6 }))
          : _createCommentVNode("", true),
        (_ctx.pageName=='cases' && _ctx.currTab=='典型\n客户')
          ? (_openBlock(), _createBlock(_component_CasesClients, { key: 7 }))
          : _createCommentVNode("", true),
        (_ctx.pageName=='cases' && _ctx.currTab=='项目\n分类')
          ? (_openBlock(), _createBlock(_component_CasesCategories, { key: 8 }))
          : _createCommentVNode("", true),
        (_ctx.pageName=='research' && _ctx.currTab=='查酒店')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_HotelLocator)
            ]))
          : _createCommentVNode("", true),
        (_ctx.pageName=='research' && _ctx.currTab=='品牌墙')
          ? (_openBlock(), _createBlock(_component_ToolListBW, {
              key: 10,
              currTab: '管理集团\n及品牌'
            }))
          : _createCommentVNode("", true),
        (_ctx.pageName=='research' && _ctx.currTab=='实用\n导航')
          ? (_openBlock(), _createBlock(_component_ToolListMC, {
              key: 11,
              currTab: '管理集团\n及品牌'
            }))
          : _createCommentVNode("", true),
        (_ctx.pageName=='research' && _ctx.currTab=='实用\n导航')
          ? (_openBlock(), _createBlock(_component_ToolListHotels, {
              key: 12,
              currTab: '最佳\n新酒店'
            }))
          : _createCommentVNode("", true),
        (_ctx.pageName=='research' && _ctx.currTab=='实用\n导航')
          ? (_openBlock(), _createBlock(_component_ToolListHotels, {
              key: 13,
              currTab: '绿色\n酒店'
            }))
          : _createCommentVNode("", true),
        (_ctx.pageName=='research' && _ctx.currTab=='登录\n华美云')
          ? (_openBlock(), _createBlock(_component_About, {
              key: 14,
              currTab: '登录\n华美云'
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.pages.find(x=> x.data == _ctx.pageName) && _ctx.pageName!='home' && _ctx.pageName!='contact' && _ctx.pageName!='services')
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "nav_float",
          style: _normalizeStyle(_ctx.navBarStyle)
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages.find(x=> x.data == _ctx.pageName).tabs, (t) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass({nav_float_tab:true, curr:t==_ctx.currTab}),
              key: t,
              onClick: _withModifiers(($event: any) => (_ctx.onClickTab(_ctx.pageName, t)), ["stop","prevent"])
            }, _toDisplayString(_ctx.windowWidth > 800?
                t.replace('\n', '') :
                t), 11, _hoisted_11))
          }), 128))
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.pages.find(x=> x.data == _ctx.pageName) && _ctx.pageName=='services')
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "nav_float",
          style: _normalizeStyle(_ctx.navBarStyle)
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages.find(x=> x.data == _ctx.pageName).tabs, (t) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass({nav_float_tab:true, curr:t==_ctx.currTab}),
              key: t,
              onClick: _withModifiers(($event: any) => (_ctx.scrollTo(t)), ["stop","prevent"])
            }, _toDisplayString(_ctx.windowWidth > 800?
                t.replace('\n', '') :
                t), 11, _hoisted_12))
          }), 128))
        ], 4))
      : _createCommentVNode("", true),
    _createVNode(_component_CallForAction, { style: {"z-index":"0"} })
  ]))
}